import { useWatch } from 'react-hook-form';
import Button from '@/components/UI/Button';
import { HookForm } from '@/components/UI/HookForm/Form';
import { HookReactSingleSelect } from '@/components/UI/HookForm/Form/ReactSelect';
import { HookFormProvider } from '@/components/UI/HookForm/Provider';
import Modal from '@/components/UI/Modal';
import { useCategoryGroup, useCategorySubGroup } from '@/hooks/ReactQueryHooks/useCategoryQuery';
import type { CategoriesGroup } from '@/types/Category';

interface AddCategoryFilterFormProps {
  handleModal: (name: string) => void;
  handleApplyFilter: (filterData: any) => void;
}

const AddCategoryFilterBaseForm = (props: AddCategoryFilterFormProps) => {
  const { handleModal, handleApplyFilter } = props;
  const groupValues = useWatch({ name: 'groupId' });

  const fetchCategoriesGroup = useCategoryGroup({});
  const categoriesGroup = fetchCategoriesGroup?.data?.data;

  const fetchCategoriesSubGroup = useCategorySubGroup({ group: groupValues });
  const categoriesSubGroup = fetchCategoriesSubGroup?.data?.data;

  return (
    <HookForm onSubmit={handleApplyFilter}>
      <h2 className='m-0 text-primaryColor-normal'>Category Filter</h2>
      <dl className='my-5 space-y-5'>
        <div className='flex w-full justify-between items-center'>
          <dt>Category Group</dt>
          <dd className='w-2/3'>
            <HookReactSingleSelect
              id='filterCategoryGroup'
              name='groupId'
              options={categoriesGroup}
              getOptionLabel={(option) => (option as CategoriesGroup).name}
              getOptionValue={(option) => (option as CategoriesGroup).id.toString()}
            />
          </dd>
        </div>
        <div className='flex w-full justify-between items-center'>
          <dt>Category Sub Group</dt>
          <dd className='w-2/3'>
            <HookReactSingleSelect
              id='filterCategorySubGroup'
              name='subGroupId'
              options={categoriesSubGroup}
              getOptionLabel={(option) => (option as CategoriesGroup).name}
              getOptionValue={(option) => (option as CategoriesGroup).id.toString()}
            />
          </dd>
        </div>
      </dl>
      <div className='flex gap-4 justify-end pt-5'>
        <Button label='Cancel' btnStyle='btn-neutral' type='button' onClick={() => handleModal('addFilter')} />
        <Button label='Apply' btnStyle='btn-primary' type='submit' />
      </div>
    </HookForm>
  );
};

export const AddCategoryFilterForm = (props: AddCategoryFilterFormProps) => {
  return (
    <Modal customStyle='overflow-visible'>
      <HookFormProvider>
        <AddCategoryFilterBaseForm {...props} />
      </HookFormProvider>
    </Modal>
  );
};
